<template>
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <div class="pop_tit _flex">
            <p>자료집 {{ state.idx === 0 ? "등록" : "수정" }}</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="sign_form">
            <ul>
                <li class="imp">
                    <label for="title" class="form_li_tit">제목</label>
                    <input id="title" type="text" v-model="state.data.title" />
                </li>
                <li class="file_wrap imp">
                    <span class="form_li_tit">썸네일</span>
                    <label for="file_file_thumbnail">
                        <input id="file_file_thumbnail" type="file" placeholder="" accept="image/*" @change="changethumbnail" />
                        <div class="thumbnail_preview">
                            <img :src="state.data.thumbnail ? state.data.thumbnail : ''" alt="" @error="CommonUtils.errorImg" />
                        </div>
                        <p class="p_info">위 이미지 영역을 클릭해주세요.</p>
                        <p class="p_info">50M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                    </label>
                </li>
                <li class="file_wrap imp">
                    <span class="form_li_tit">첨부</span>
                    <label for="area_file">
                        <input id="area_file" type="file" placeholder="" multiple @change="handleFiles" />
                        <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하거나 파일을 드래그하여 첨부해주세요</div>
                        <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                        <p class="p_info">각 파일은 200MB 이하로 업로드 가능합니다. (최대 5개)</p>
                    </label>
                    <div class="file_list">
                        <div class="file" v-for="(item, idx) in state.data.fileList" :key="idx">
                            <span class="file_name" @click="downloadFile(item.file, item.fileRealName)">{{ item.fileRealName }}</span>
                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>

                        <div class="file" v-for="(item, index) in state.file" :key="index">
                            <span class="file_name">{{ item.name }}</span>
                            <button class="file_del icon_wrap" @click="removeFile(index)">
                                <img src="img/close_02.png" alt="" />
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="_flex _center btn_wrap">
                <button class="submit_btn _130 _main_blue" @click="save" v-text="state.mode ? '등록' : '수정'"></button>
            </div>
        </div>
    </div>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeDefaultModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>

<script lang="ts">
    import { onMounted, reactive, types, apiService, ModalDefault, watch, getMessageByCode, CommonUtils } from "@/BaseComponent";

    export default {
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        emits: ["close", "callback"],
        components: { ModalDefault },
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: props.idx,
                data: {} as types.ResArchiveVOForApi,
                file: [] as Array<File>,

                thumbnail: {} as File,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                mode: true as boolean, // true: add, false: modify
            });

            onMounted(async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;

                    state.mode = false;
                } else {
                    state.data = {} as types.ResArchiveVOForApi;
                    state.idx = 0;

                    state.mode = true;
                }
            });

            watch(props, async () => {
                if (props.data) {
                    state.data = props.data;
                    state.idx = state.data.idx;

                    state.mode = false;
                } else {
                    state.data = {} as types.ResArchiveVOForApi;
                    state.idx = 0;

                    state.mode = true;
                }
            });

            const closeModal = () => {
                if (state.file && state.file.length === 0 && state.data.fileList && state.data.fileList.length === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "첨부파일을 등록해주세요.";
                    state.isShowModal = true;
                    return;
                }
                emit("close");
            };
            const closeDefaultModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "callback") {
                    emit("callback");
                } else {
                    state.isShowModal = false;
                }
            };

            const save = async () => {
                if (
                    !state.data.title ||
                    (!state.data.thumbnail && !state.thumbnail.name) ||
                    (state.file.length === 0 && state.data.fileList.length === 0)
                ) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "제목, 썸네일, 첨부파일을 확인해주세요.";
                    state.isShowModal = true;
                } else if (state.file.length > 5) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "첨부파일은 최대 5개까지 첨부 가능합니다.";
                    state.isShowModal = true;
                } else {
                    if (state.mode) add();
                    else modify();
                }
            };

            const add = async () => {
                const param: types.ReqBoardForArchive = {
                    title: state.data.title,
                    file_thumbnail: state.thumbnail,
                    file: state.file,
                };
                const res = await apiService.archives.add(param);
                if (res.returnCode === 0) {
                    state.modalTab = 7;
                    state.modalTitle = "안내";
                    state.modalContent = "등록이 완료되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };
            const modify = async () => {
                const param: types.ReqBoardForArchiveForModify = {
                    idx: state.idx,
                    title: state.data.title,
                    ...(state.thumbnail.name ? { file_thumbnail: state.thumbnail } : {}),
                    ...(state.file.length > 0 ? { file: state.file } : {}),
                };
                const res = await apiService.archives.modify(param);
                if (res.returnCode === 0) {
                    state.modalTab = 7;
                    state.modalTitle = "안내";
                    state.modalContent = "수정이 완료되었습니다.";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "안내";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const handleFiles = (e: any) => {
                const target = e.target as HTMLInputElement;
                const file = e.target.files[0];
                if (!file) return;

                state.file = Array.from(e.target.files);
                target.value = "";
            };

            const removeFile = (index: number) => state.file.splice(index, 1);

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.archives.removeForFile(state.data.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = state.data.fileList.findIndex((item: any) => item.idx === idxFile);
                    if (index !== -1) {
                        state.data.fileList.splice(index, 1);
                    }
                }
            };

            const changethumbnail = (e: any) => {
                const target = e.target as HTMLInputElement;
                if (!target.files) return;

                const files: File[] = Array.from(target.files);

                const isFiles = files.filter((file) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "이미지 파일만 업로드할 수 있습니다.";
                    state.isShowModal = true;

                    target.value = "";
                    return;
                }

                state.thumbnail = files[0];
                state.data.thumbnail = URL.createObjectURL(state.thumbnail);
                target.value = "";
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            return {
                state,
                closeModal,
                removeFile,
                save,
                handleFiles,
                fileRemove,
                callBackModal,
                closeDefaultModal,
                changethumbnail,
                CommonUtils,
                downloadFile,
            };
        },
    };
</script>

<style scoped>
    .thumbnail_preview {
        max-height: 150px;
        min-height: 100px;
        max-width: 150px;
        min-width: 100px;
        border: 1px solid lightgray;
    }
    .thumbnail_preview img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
